export default __webpack_public_path__ + "search-examples-uitextfield-search-thumbnail-960-50e1a9edfa2a06aac1040aa57a7538f2.webp";